import { useState, useEffect } from 'react';
const API = process.env.REACT_APP_API_URL || '';
export default function AdminPortfolio({ user, onLogout }) {
  const [companies, setCompanies] = useState([]); const [loading, setLoading] = useState(true); const [showAdd, setShowAdd] = useState(false); const [newCo, setNewCo] = useState({ name:'', slug:'', logoInitials:'', industry:'' });
  useEffect(() => { fetch(`${API}/api/companies`, { credentials:'include' }).then(r=>r.json()).then(d=>{ setCompanies(Array.isArray(d)?d:[]); setLoading(false); }).catch(()=>setLoading(false)); }, []);
  function goTo(slug) { window.history.pushState({}, '', `/${slug}`); window.location.reload(); }
  async function addCompany(e) {
    e.preventDefault();
    const res = await fetch(`${API}/api/companies`, { method:'POST', credentials:'include', headers:{'Content-Type':'application/json'}, body:JSON.stringify(newCo) });
    const data = await res.json();
    if (data.success) { setCompanies(prev => [...prev, data.company]); setShowAdd(false); setNewCo({ name:'', slug:'', logoInitials:'', industry:'' }); }
  }
  return (
    <div className="dash">
      <div className="topbar">
        <div className="topbar-left"><div className="portal-logo small">SCV</div><div><div className="co-name">Seven Circles Ventures</div><div className="co-sub">Portfolio · {user.fullName}</div></div></div>
        <div className="topbar-right"><button className="btn-outline" onClick={() => setShowAdd(true)}>+ Add company</button><button className="btn-ghost" onClick={onLogout}>Sign out</button></div>
      </div>
      {loading ? <div style={{textAlign:'center',padding:'3rem',color:'var(--text-muted)'}}>Loading...</div> : (
        <div className="portfolio-grid">
          {companies.map(co => (
            <div key={co.id} className="company-card" onClick={() => goTo(co.slug)}>
              <div className="company-card-header">
                <div className="company-avatar">{co.logo_initials||co.name.slice(0,2).toUpperCase()}</div>
                <div><div className="company-card-name">{co.name}</div><div className="company-card-industry">{co.industry}</div></div>

              </div>
              <div className="company-card-footer"><span className="view-link">View dashboard →</span></div>
            </div>
          ))}
        </div>
      )}
      {showAdd && (
        <div className="modal-backdrop" onClick={() => setShowAdd(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <h2>Add portfolio company</h2>
            <form onSubmit={addCompany} className="login-form">
              <div className="field"><label>Company name</label><input value={newCo.name} onChange={e=>setNewCo(p=>({...p,name:e.target.value}))} placeholder="Studio G" required /></div>
              <div className="field"><label>URL slug</label><input value={newCo.slug} onChange={e=>setNewCo(p=>({...p,slug:e.target.value.toLowerCase().replace(/\s/g,'')}))} placeholder="studiog" required /><span className="field-hint">scvportal.com/{newCo.slug||'slug'}</span></div>
              <div className="field"><label>Logo initials</label><input value={newCo.logoInitials} onChange={e=>setNewCo(p=>({...p,logoInitials:e.target.value.slice(0,3).toUpperCase()}))} placeholder="SG" maxLength={3} /></div>
              <div className="field"><label>Industry</label><input value={newCo.industry} onChange={e=>setNewCo(p=>({...p,industry:e.target.value}))} placeholder="Plumbing / Mechanical" /></div>
              <div style={{display:'flex',gap:8,marginTop:8}}><button type="submit" className="login-btn" style={{flex:1}}>Add company</button><button type="button" className="btn-outline" onClick={()=>setShowAdd(false)}>Cancel</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
